module.exports = __webpack_public_path__ + "img/checkbox.76d84514.svg";